module.exports = __webpack_public_path__ + "static/media/own-ingredients-icon.9693d643.svg";